import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=216d1a32&scoped=true&"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=216d1a32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d1a32",
  null
  
)

export default component.exports